"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
const gatherBy_1 = require("./gatherBy");
function groupBy(array, pathOrFn) {
    const gatherFn = (result, key, element) => {
        if (!(key in result))
            result[key] = [];
        result[key].push(element);
    };
    return (0, gatherBy_1.gatherBy)(array, pathOrFn, gatherFn);
}
exports.groupBy = groupBy;
//# sourceMappingURL=groupBy.js.map